import { getSessionToken, clearSession } from './auth';

export async function apiFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const token = getSessionToken();
  const headers = new Headers(options.headers);
  if (token) headers.set('Authorization', `Bearer ${token}`);
  if (!headers.has('Content-Type') && options.body && typeof options.body === 'string') {
    headers.set('Content-Type', 'application/json');
  }

  const res = await fetch(url, { ...options, headers });

  // Only trigger reload on 401 if we actually had a token (session expired).
  // If there's no token, the user is simply not logged in — don't reload.
  if (res.status === 401 && token) {
    clearSession();
    window.location.reload();
  }

  return res;
}
